// Define the type for the element being added
interface Element {
    id: string;
    type: string;
    name: string;
    opacity: number;
    visible: boolean;
    selectable: boolean;
    removable: boolean;
    alwaysOnTop: boolean;
    showInExport: boolean;
    x: number;
    y: number;
    width: number;
    height: number;
    rotation: number;
    animations?: any[];
    draggable?: boolean;
    resizable?: boolean;
    contentEditable: boolean;
    styleEditable: boolean;
    text: string;
    fontSize: number;
    fontFamily: string;
    fontStyle: string;
    fontWeight: string;
    fill: string;
    align: string;
    verticalAlign: string;
    lineHeight: number;
    letterSpacing: number;
    backgroundEnabled?: boolean;
    backgroundColor?: string;
    backgroundOpacity?: number;
    backgroundCornerRadius?: number;
    backgroundPadding?: number;
}

// Define the type for the page
interface Page {
    addElement: (element: Element) => void;
}

// Define the type for the store
interface Store {
    pages: Page[];
    history: {
        clear: () => void;
    };
}

// Reusable function to create text elements
const createTextElement = (
    id: string,
    text: string,
    x: number,
    y: number,
    width: number
): Element => ({
    id,
    type: "text",
    name: "",
    opacity: 1,
    visible: true,
    selectable: false,
    removable: false,
    alwaysOnTop: true,
    showInExport: true,
    x,
    y,
    width,
    height: 11,
    rotation: 0,
    draggable: false,
    resizable: true,
    contentEditable: true,
    styleEditable: false,
    text,
    fontSize: 7,
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "normal",
    fill: "grey",
    align: "center",
    verticalAlign: "top",
    lineHeight: 1.2,
    letterSpacing: 0,
});


export const addIdentifierAreaToProfessionalWindow = (store: Store): void => {
    const page = store.pages[0];

    const elements: Element[] = [
        createTextElement("cont-id-placeholder", "C:", 283.5, 250, 11),
        createTextElement("contId", "0000001", 291.5, 250, 30),
        createTextElement("sequence-id-placeholder", "| S:", 321.5, 250, 12),
        createTextElement("sequence", "0000001", 333.5, 250, 29),
        createTextElement("template-id-placeholder", "| T:", 360.7, 250, 14),
        createTextElement("templateId", "0001034", 372.6, 250, 29),
        createTextElement("order-id-placeholder", "| O:", 401.6, 250, 11),
        createTextElement("orderId", "0000127", 412.6, 250, 29),
    ];

    elements.forEach(element => page.addElement(element));
    store.history.clear();
};

export const addIdentifierAreaToProfessionalNonWindow = (store: Store, pageIndex: number = 0): void => {
    const page = store.pages[pageIndex];

    const elements: Element[] = [
        createTextElement("cont-id-placeholder", "C:", 22, 1033, 11),
        createTextElement("contId", "0000001", 30, 1033, 30),
        createTextElement("sequence-id-placeholder", "| S:", 58, 1033, 12),
        createTextElement("sequence", "0000001", 68, 1033, 29),
        createTextElement("template-id-placeholder", "| T:", 95, 1033, 14),
        createTextElement("templateId", "0001034", 107, 1033, 29),
        createTextElement("order-id-placeholder", "| O:", 136, 1033, 11),
        createTextElement("orderId", "0000127", 147, 1033, 29),
    ];

    elements.forEach(element => page.addElement(element));
    store.history.clear();
};